'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BibScreenReaderDescription;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _baseByAuthorBlock = require('@bibliocommons/base-by-author-block');

var _baseByAuthorBlock2 = _interopRequireDefault(_baseByAuthorBlock);

var _formatIndicator = require('@bibliocommons/format-indicator');

var _formatIndicator2 = _interopRequireDefault(_formatIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BibScreenReaderDescription(_ref) {
  var bibBrief = _ref.bibBrief;

  var title = bibBrief.get('title');
  var authors = bibBrief.get('authors');
  var format = bibBrief.get('format');

  return _react2.default.createElement(
    'div',
    { className: 'cp-bib-screen-reader-description' },
    title,
    format ? _react2.default.createElement(_formatIndicator2.default, { format: format.toUpperCase() }) : null,
    ' ',
    _react2.default.createElement(_baseByAuthorBlock2.default, {
      authors: authors,
      renderAsLink: false })
  );
}

BibScreenReaderDescription.propTypes = {
  bibBrief: _reactImmutableProptypes2.default.map
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-bib-screen-reader-description/lib/components/BibScreenReaderDescription.component.js
// module id = 1471
// module chunks = 1